import Header from "./header";
import logo from "../logo.svg";

function Home() {
  return (
    <>
      <Header />
      <h2>Home Page</h2>
      <img src={logo} className="App-logo" alt="logo" />
    </>
  );
}

export default Home;
